import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Error404 from '../views/404.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
    },
    {
        path: '/initiativer',
        name: 'Articles',
        component: () => import('../views/Articles.vue'),
    },
    {
        path: '/blogg',
        name: 'Blog',
        component: () => import('../views/Blog.vue'),
    },
    {
        path: '/tiltak/:slug',
        name: 'Article',
        component: () => import('../views/Article.vue'),
    },
    {
        path: '/blogg/:slug',
        name: 'Post',
        component: () => import('../views/Post.vue'),
    },
    {
        path: '/sok',
        name: 'Search',
        component: () => import('../views/Search.vue'),
    },
    {
        path: '*',
        name: 'Not Found',
        component: Error404,
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior() {
        window.scrollTo(0, 0);
    },
});

export default router;
